import { Icon, IconProps } from "@chakra-ui/react"

export const TickIcon = (props: IconProps) => {
  const ariaLabel = props["aria-label"]
  return (
    <Icon width="29" height="24" viewBox="0 0 29 24" fill="none" {...props}>
      {ariaLabel && <title>{ariaLabel}</title>}
      <path
        d="M9.53478 23.0231L0.0688477 13.7826L5.25257 9.50036L9.53478 13.7826L23.0575 0.0344238L28.2413 4.31663L9.53478 23.0231Z"
        fill="currentColor"
      />
    </Icon>
  )
}
